import axios from 'axios';
import axiosRetry from 'axios-retry';

import { captureCameraError } from 'src/utils/errorReporting';

export interface CameraApiResponse<T> {
  message: string;
  obj: T;
}

export const CameraApiEnum = {
  GET_VERSIONS: '/getVersions',
  GET_VOLUME: '/amixerCget',
  SET_VOLUME: '/setin',
  GET_ALL_LANGUAGES: '/getLanguages',
  GET_STORAGE: '/getStorage',
  SET_LANGUAGE: '/setLanguage',
  SET_SYSTEM_CONFIGURATION: '/DeviceInfo',
  AUTO_TAKE_PHOTO: '/dev/AutoTakePhoto',
  GET_CURRENT_CAPTURE_PROCESS: 'dev/AutoState',
  EXIST_CAPTURE_PROCESS: '/dev/ResetCamera',
  CONTINUE_CAPTURE_PROCESS: '/dev/continueCapture',
  SKIP_CURRENT_EYE: '/dev/ignore',
  SHUT_DOWN: '/shutdown',
  REBOOT: '/Reboot',
  GET_BATTERY_INFO: '/getBatteryInfo',
  GET_DEVICE_SN: '/dev/DeviceSN',
  GET_SETTINGS: '/getSettings',
  SAY: '/dev/TTS',
  FORMAT_STORAGE: '/DeviceFormatting',
};

export const CAMERA_SIMULATOR_IP = '127.0.0.1';
export const CAMERA_STATIC_IP = '192.168.3.10';

const MAX_RETRIES = 3;

const axiosInstance = axios.create({
  timeout: 5000,
});

axiosRetry(axiosInstance, {
  retries: MAX_RETRIES,
  shouldResetTimeout: true,
  retryCondition: () => true,
  retryDelay: () => 1000,
});

axiosInstance.interceptors.request.use(
  function (config) {
    return config;
  },
  function (error) {
    captureCameraError(error, {
      customMessage: 'Camera Request Error',
      operation: 'Camera Request',
      tags: {
        error_type: 'camera_request_error',
      },
    });
    return Promise.reject(error);
  },
);

axiosInstance.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    captureCameraError(error, {
      customMessage: 'Camera Response Error',
      operation: 'Camera Response',
      tags: {
        error_type: 'camera_response_error',
      },
    });
    return Promise.reject(error);
  },
);

export default axiosInstance;
